import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-search-svg-icon',
  imports: [NgClass],
  templateUrl: './search-svg-icon.component.html',
  styleUrl: './search-svg-icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchSvgIconComponent {
  @Input({ required: true }) class!: string;
  @Input() fillColor = '#FFFEFE';
  // @Input() class = 'w-6 h-6 text-beige sm:hover:cursor-pointer'
}
